import React from 'react';
import AgendaFormFilterCats from './AgendaFormFilterCats';
import AgendaFormFilterPublics from './AgendaFormFilterPublics';
import AgendaFormFilterQuartiers from './AgendaFormFilterQuartiers';
import AgendaFormFilterParticipation from './AgendaFormFilterParticipation';
import AgendaFormFilterDates from './AgendaFormFilterDates';

const AgendaForm = ({AgendaFilterActiveOther, AgendaFilterActivePublic, AgendaFilterActiveQuartier, onSubmit, OnChangeFilterCats, OnChangeFilterPublic, OnChangeFilterQuartier, OnChangeFilterParticipation, OnClickDatePickerOpenClose, FilterDateIsOpen, FilterDateCurrent, OnClickDatePickerReset, OnClickDatePickerThisDay, OnClickDatePickerThisWeek, OnClickDatePickerThisWeekend, datePickerStartValue, datePickerShowStartValue, OnChangeDatePickerStart, datePickerEndValue, datePickerShowEndValue, OnChangeDatePickerEnd, ...rest}) => {
	// Validation des props et gestion des erreurs
	if (typeof onSubmit !== 'function') {
		return (
			<div role="region" aria-label="Formulaire de filtres de l'agenda" className="agenda-form-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : fonction de soumission manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Gestion des événements clavier
	const handleKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			onSubmit(event)
		}
	}

	return (
		<div role="region" aria-label="Formulaire de filtres de l'agenda" className="agenda-form-container">
			<form 
				id="agenda-filters" 
				className="generic-filters agenda-filters" 
				onSubmit={onSubmit}
				role="form"
				aria-label="Filtres de recherche pour l'agenda des événements"
				aria-describedby="agenda-form-description"
			>
				{/* Description accessible pour les lecteurs d'écran */}
				<div 
					id="agenda-form-description" 
					className="visually-hidden" 
					aria-live="polite"
				>
					Formulaire de filtres pour rechercher des événements dans l'agenda de Roubaix
				</div>

				<div className="generic-filters-header agenda-filters-header" aria-label="En-tête des filtres">
					<h1 className="generic-filters-header-title agenda-filters-header-title" id="agenda-form-title">
						<span>Sortir</span> à Roubaix
					</h1>
					<div className="agenda-filters-header-what" role="group" aria-labelledby="agenda-form-title" aria-label="Recherche textuelle">
						<div className="agenda-filters-header-what-group">
							<div className="agenda-filters-text" role="group" aria-label="Champ de recherche">
								<input 
									id="agenda-filters-text" 
									{...rest}
									aria-label="Rechercher un événement"
									aria-describedby="agenda-form-description"
								/>
							</div>
							<button 
								className="agenda-filters-submit" 
								onClick={onSubmit} 
								onKeyDown={handleKeyDown} 
								type="button"
								aria-label="Lancer la recherche"
								aria-describedby="agenda-form-description"
							>
								<span aria-hidden="true">Go</span>
							</button>
						</div>
					</div>
				</div>

				<div role="group" aria-label="Filtres de catégories" aria-describedby="agenda-form-description" class="generic-filters-select agenda-filters-select-category">
					<AgendaFormFilterCats 
						AgendaFilterActiveOther={AgendaFilterActiveOther} 
						OnChangeFilterCats={OnChangeFilterCats} 
					/>
				</div>

				<div role="group" aria-label="Filtres de dates" aria-describedby="agenda-form-description" class="generic-filters-select agenda-filters-dates">
					<AgendaFormFilterDates 
						OnClickDatePickerOpenClose={OnClickDatePickerOpenClose}
						FilterDateIsOpen={FilterDateIsOpen}
						FilterDateCurrent={FilterDateCurrent}
						OnClickDatePickerReset={OnClickDatePickerReset}
						OnClickDatePickerThisDay={OnClickDatePickerThisDay}
						OnClickDatePickerThisWeek={OnClickDatePickerThisWeek}
						OnClickDatePickerThisWeekend={OnClickDatePickerThisWeekend}
						datePickerStartValue={datePickerStartValue} 
						datePickerShowStartValue={datePickerShowStartValue} 
						OnChangeDatePickerStart={OnChangeDatePickerStart} 
						datePickerEndValue={datePickerEndValue} 
						datePickerShowEndValue={datePickerShowEndValue} 
						OnChangeDatePickerEnd={OnChangeDatePickerEnd}
					/>
				</div>

				<div role="group" aria-label="Filtres de publics" aria-describedby="agenda-form-description" class="generic-filters-select agenda-filters-select-publics">
					<AgendaFormFilterPublics 
						AgendaFilterActivePublic={AgendaFilterActivePublic} 
						OnChangeFilterPublic={OnChangeFilterPublic}
					/>
				</div>

				<div role="group" aria-label="Filtres de quartiers" aria-describedby="agenda-form-description" class="generic-filters-select agenda-filters-select-quartiers">
					<AgendaFormFilterQuartiers 
						AgendaFilterActiveQuartier={AgendaFilterActiveQuartier} 
						OnChangeFilterQuartier={OnChangeFilterQuartier}
					/>
				</div>

				<div role="group" aria-label="Filtres de participation" aria-describedby="agenda-form-description" class="generic-filters-select agenda-filters-select-participation">
					<AgendaFormFilterParticipation 
						OnChangeFilterParticipation={OnChangeFilterParticipation}
					/>
				</div>

				{/* Message de statut pour les lecteurs d'écran */}
				<div 
					className="visually-hidden" 
					aria-live="polite" 
					aria-label="Statut des filtres"
				>
					Formulaire de filtres chargé avec succès
				</div>
			</form>
		</div>
	)
}

export default AgendaForm;
